import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import React, { useContext } from 'react';
var languagesNames = {
  fr: {
    fr: 'Français',
    en: 'Anglais',
    de: 'Allemand',
    it: 'Italien'
  },
  en: {
    fr: 'French',
    en: 'English',
    de: 'German',
    it: 'Italian'
  },
  de: {
    fr: 'Französisch',
    en: 'English',
    de: 'Deutsche',
    it: 'Italienisch'
  },
  it: {
    fr: 'Francese',
    en: 'Inglese',
    de: 'Tedesco',
    it: 'Italiano'
  }
};
var flags = {
  fr: 'FR',
  en: 'GB',
  de: 'DE',
  it: 'IT'
};
export var TranslationContext = /*#__PURE__*/function () {
  function TranslationContext(currentLanguage, defaultLanguage, availableLanguages, updateContext) {
    _classCallCheck(this, TranslationContext);

    this.currentLanguage = currentLanguage;
    this.defaultLanguage = defaultLanguage;
    this.availableLanguages = availableLanguages;
    this.updateContext = updateContext;
  }

  _createClass(TranslationContext, [{
    key: "language",
    get: function get() {
      return this.currentLanguage || this.defaultLanguage;
    }
  }, {
    key: "languages",
    get: function get() {
      return this.availableLanguages;
    }
  }, {
    key: "getUnlocalizedPath",
    get: function get() {
      if (window.location.pathname.search('/' + this.language) === 0) {
        return window.location.pathname.replace('/' + this.language, '');
      } else {
        return window.location.pathname;
      }
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      if (this.availableLanguages.includes(language)) {
        this.updateContext(new TranslationContext(language, this.defaultLanguage, this.availableLanguages, this.updateContext));
      } else {
        throw new Error("Language ".concat(language, " is not available"));
      }
    }
  }, {
    key: "mapToCountryFlag",
    value: function mapToCountryFlag(language) {
      return flags[language];
    }
  }, {
    key: "mapFromCountryFlag",
    value: function mapFromCountryFlag(country) {
      var _this = this;

      return this.availableLanguages.filter(function (lang) {
        return _this.mapToCountryFlag(lang) === country;
      })[0];
    }
  }, {
    key: "mapToLanguageName",
    value: function mapToLanguageName(language) {
      return languagesNames[this.language][language];
    }
  }]);

  return TranslationContext;
}();
export var ReactTranslationContext = React.createContext(null);
export var useLanguageCode = function useLanguageCode() {
  var translationContext = useContext(ReactTranslationContext);
  return [translationContext === null || translationContext === void 0 ? void 0 : translationContext.language, translationContext === null || translationContext === void 0 ? void 0 : translationContext.setLanguage.bind(translationContext)];
};
export var useUnlocalizedPath = function useUnlocalizedPath() {
  var translationContext = useContext(ReactTranslationContext);
  return translationContext === null || translationContext === void 0 ? void 0 : translationContext.getUnlocalizedPath;
};